import { type IPikProjectsItemViewModel } from 'shared/components/PikProjects/external/models/PikProjectsItemViewModel';

import { type IChipsDataService } from '../IChipsDataService';

import { ChipsDataService } from './ChipsDataService';

/**
 * @description Сервис для работы с элементами проекта ПИК
 * @param items - Массив элементов проекта ПИК
 * @example
 * const pikProjectsChipsDataService = new PikProjectsChipsDataService(items);
 * const defaultItem = pikProjectsChipsDataService.defaultItem;
 * const activeItem = pikProjectsChipsDataService.getActiveItem('Плитками');
 */
export class PikProjectsChipsDataService
  extends ChipsDataService<IPikProjectsItemViewModel>
  implements IChipsDataService<IPikProjectsItemViewModel> {}
